/*
  AgriEID Weighing Value Calculator
  Upload this file to: Online Store > Themes > Edit Code > Assets > Add new asset
*/
document.addEventListener('DOMContentLoaded', function(){
  var $=function(id){return document.getElementById(id)};
  var fmt=function(n){return '$'+Math.round(n).toLocaleString('en-AU')};
 
  var LIGHT_WT=220,TARGET_WT=280,LIGHT_PRICE=6.00;
  var GROWTH=0.05;
  var SYSTEM_COST=2650;
 
  var slider=$('i-pct');
  var fill=$('o-fill');
  var pctDisp=$('o-pct');
 
  if(!slider||!fill||!pctDisp){return;}
 
  function updateFill(){
    var v=parseInt(slider.value);
    fill.style.width=((v-5)/(40-5))*100+'%';
    pctDisp.textContent=v+'%';
  }
 
  function calc(){
    var herd=parseInt($('i-herd').value)||50;
    var price=parseFloat($('i-price').value)||5.50;
    var pct=parseInt(slider.value)||20;
    var numLight=Math.round(herd*pct/100);
 
    /* STREAM 1: Weight Gain */
    var lightRet=LIGHT_WT*LIGHT_PRICE;
    var tgtRet=TARGET_WT*price;
    var diffHead=tgtRet-lightRet;
    var wtYr=Math.round(numLight*diffHead);
 
    /* STREAM 2: Health Savings — line items that add up */
    var h_dose=Math.round(herd*5);
    var h_vet=Math.round(herd*15);
    var h_fatal=Math.round(Math.ceil(herd/50)*tgtRet*0.5);
    var h_fert=Math.round(herd*10);
    var medYr=h_dose+h_vet+h_fatal+h_fert;
 
    /* STREAM 3: Culling, Genetics & AI — line items that add up */
    var c_adg=Math.round(herd*20);
    var c_gen=Math.round(herd*12);
    var c_infert=Math.round(herd*8);
    var c_ai=Math.round(herd*15);
    var cullYr=c_adg+c_gen+c_infert+c_ai;
 
    /* Year 1 total */
    var yr1Total=wtYr+medYr+cullYr;
    var perHead=herd>0?Math.round(yr1Total/herd):0;
    var paybackMonths=yr1Total>0?Math.max(1,Math.round(SYSTEM_COST/yr1Total*12)):99;
 
    /* Update Stream 1 */
    $('o-light').textContent=fmt(lightRet);
    $('o-tprice').textContent='@ $'+price.toFixed(2)+'/kg';
    $('o-target').textContent=fmt(tgtRet);
    $('t1-perhead').textContent=fmt(diffHead);
    $('t1-nlight').textContent=numLight+' head';
    $('t1-nlight2').textContent=numLight;
    $('t1-pct2').textContent=pct;
    $('t1-herd').textContent=herd;
    $('t1-total').textContent=fmt(wtYr)+'/yr';
 
    /* Update Stream 2 */
    $('t2-dose').textContent=fmt(h_dose)+'/yr';
    $('t2-vet').textContent=fmt(h_vet)+'/yr';
    $('t2-fatal').textContent=fmt(h_fatal)+'/yr';
    $('t2-fert').textContent=fmt(h_fert)+'/yr';
    $('t2-total').textContent=fmt(medYr)+'/yr';
 
    /* Update Stream 3 */
    $('t3-adg').textContent=fmt(c_adg)+'/yr';
    $('t3-gen').textContent=fmt(c_gen)+'/yr';
    $('t3-infert').textContent=fmt(c_infert)+'/yr';
    $('t3-ai').textContent=fmt(c_ai)+'/yr';
    $('t3-total').textContent=fmt(cullYr)+'/yr';
 
    /* Update Year 1 summary */
    $('s-wg').textContent=fmt(wtYr);
    $('s-med').textContent=fmt(medYr);
    $('s-cull').textContent=fmt(cullYr);
    $('s-yr1').textContent=fmt(yr1Total);
    $('s-perhead').textContent=fmt(perHead);
    $('s-payback').textContent=paybackMonths+' months';
 
    /* Breakdown bars */
    var maxVal=Math.max(wtYr,medYr,cullYr,1);
    $('o-bar1').style.width=Math.round(wtYr/maxVal*100)+'%';
    $('o-bar1').textContent=fmt(wtYr);
    $('o-bar2').style.width=Math.round(medYr/maxVal*100)+'%';
    $('o-bar2').textContent=fmt(medYr);
    $('o-bar3').style.width=Math.round(cullYr/maxVal*100)+'%';
    $('o-bar3').textContent=fmt(cullYr);
 
    /* 5-Year Table */
    var tbody=$('o-5yr');
    tbody.innerHTML='';
    var cumul=0,wg=wtYr,cl=cullYr;
 
    for(var yr=1;yr<=5;yr++){
      var med=medYr;
      var annual=wg+med+cl;
      cumul+=annual;
      var ph=herd>0?Math.round(annual/herd):0;
      var tr=document.createElement('tr');
      tr.innerHTML=
        '<td>Year '+yr+'</td>'+
        '<td class="g">'+fmt(wg)+'</td>'+
        '<td>'+fmt(med)+'</td>'+
        '<td>'+fmt(cl)+'</td>'+
        '<td>'+fmt(ph)+'</td>'+
        '<td class="g">'+fmt(annual)+'</td>'+
        '<td class="b">'+fmt(cumul)+'</td>';
      tbody.appendChild(tr);
      wg=Math.round(wg*(1+GROWTH));
      cl=Math.round(cl*(1+GROWTH));
    }
 
    var totalTr=document.createElement('tr');
    totalTr.className='total-row';
    totalTr.innerHTML='<td colspan="6" style="text-align:right;white-space:nowrap">5-Year Total</td><td>'+fmt(cumul)+'</td>';
    tbody.appendChild(totalTr);
 
    $('o-total').textContent=fmt(cumul);
  }
 
  /* Events */
  slider.addEventListener('input',function(){updateFill();calc()});
  if($('btn-calc')){$('btn-calc').addEventListener('click',calc);}
  ['i-herd','i-price'].forEach(function(id){
    if($(id)){
      $(id).addEventListener('input',calc);
      $(id).addEventListener('change',calc);
    }
  });
 
  updateFill();
  calc();
});
 